export const deKebab = (str: string) => {
    if (!str) return ''

    return str.replace(/(-)/g, ' ').toLowerCase()
}
